import React from 'react'
import { Link } from 'react-router-dom';
import styles from './style.module.css'

export default function DeliveryItem({ delivery, to }) {

  function _style() {
    const state = delivery.state;
    switch (state) {
      case "needs-pickup":
        return {
          text: '#000',
          bg: '#FFF',
        };
      case "in-delivery":
        return {
          text: '#FFF',
          bg: '#5d94c1',
        };
      case "delivered":
        return {
          text: '#000',
          bg: '#7bc15d',
        };
      default:
        return {
          text: '#000',
          bg: '#FFF',
        };
    }
  }

  return (
    <div className={styles.wrapper}
      style={{ backgroundColor: _style().bg }}>
      <div className={styles.textWrapper}>
        <p className={styles.header}
          style={{ color: _style().text }}>
          #{delivery.order_number}
        </p>
        <p className={styles.paragraph}
          style={{ color: _style().text }}>
          {delivery.prod.category}
        </p>
      </div>
      <div>
        <div className={styles.btnWrapper}>
          <Link to={to || `/deliveries/${delivery.order_id}`}
            style={{ width: '100%' }}
            className={'btn btn-primary'}>Open</Link>
        </div>
      </div>
    </div>
  )
}
